import React from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import { checkUserActivity, Activity, UserRole, checkUserRole } from "../../helpers/userActivity";
import { formatDateTime, formatSeconds } from "../../helpers/utils";
import Connections from "./Connections";
import { WelcomeHeader } from "../../components/WelcomeHeader";
import logo from "../../../assets/logo.png";
import { getAuthenticationType, AuthenticationType } from "../../constants/AuthenticationType";

/**
 * Główna strona aplikacji.
 * 
 * Zawartość jest inna w zależnośći od zalogowanego użytkownika.
 * 
 * Admin widzi szczegóły serwera
 * 
 * Manager/Serwis - widzi swoje połączenia
 * 
 */
class Home extends React.Component {

  /**
   * Info o serwerze i tokenie
   */
  serverInfo() {

    return (
      <div>
        <p>
          Aplikacja w trybie <b>{process.env.NODE_ENV}</b>
        </p>

        <p>
          Server api: <b>{process.env.REACT_APP_FLOW_API_SERVER}</b>
        </p>

        <p>
          Public url: <b>{process.env.PUBLIC_URL}</b>
        </p>

        <p>

          {getAuthenticationType().displayName}{" "}

          {getAuthenticationType() === AuthenticationType.JWT && this.tokenJWTInfo()}

        </p>
      </div>
    )
  }

  /**
   * Dane tokena JWT
   */
  tokenJWTInfo() {
    return (
      <>
        <b>{formatSeconds(this.props.flow24token.expiresIn)}</b> , ważny do: {" "}
        <b>{formatDateTime(this.props.flow24token.expiresAt)}</b>
      </>
    )
  }

  render() {

    const { authenticated, authenticatedUser, formatMessage } = this.props;

    //czy uzytkownik jest zalogowany
    let isLogged = authenticated && authenticatedUser;
    //czy uzytkownik ma role admina
    let isAdmin = false;
    //czy widoczne sa szczególy serwera
    let isServerInfo = false;

    if (isLogged) {
      isServerInfo = checkUserActivity(authenticatedUser, Activity.SERVER_INFO);
      isAdmin = checkUserRole(authenticatedUser, UserRole.ROLE_ADMIN);
    }

    return (
      <div>

        <div className="w3-container">
          <h1 className="w3-center">
            <img src={logo} alt="Flow24 Admin" />
          </h1>
        </div>

        <WelcomeHeader text="app.welcomeHeader.title" />

        {isServerInfo && this.serverInfo()}

        {isLogged && !isAdmin && <Connections formatMessage={formatMessage} />}

      </div>
    );
  }
}

Home.propTypes = {
  formatMessage: PropTypes.func.isRequired
};


const mapStateToProps = state => {
  return {// 
    authenticated: state.authReducer.authenticated,
    authenticatedUser: state.authReducer.authenticatedUser,
    flow24token: state.authReducer.flow24token
  };
};

export default connect(
  mapStateToProps
)(Home);

